import React, { InputHTMLAttributes, ReactNode } from 'react';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  labelPlacement?: 'left' | 'right' | 'top' | 'bottom';
  children?: ReactNode;
}

export const Checkbox: React.FC<CheckboxProps> = ({ 
  labelPlacement = 'right', 
  children, 
  className = '', 
  style,
  ...props 
}) => {
  const labelStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: props.disabled ? 'not-allowed' : 'pointer',
    opacity: props.disabled ? 0.6 : 1,
    ...style
  };

  if (labelPlacement === 'left') {
    labelStyle.flexDirection = 'row-reverse';
    labelStyle.justifyContent = 'flex-end';
  } else if (labelPlacement === 'top') {
    labelStyle.flexDirection = 'column-reverse';
    labelStyle.alignItems = 'flex-start';
  } else if (labelPlacement === 'bottom') {
    labelStyle.flexDirection = 'column';
    labelStyle.alignItems = 'flex-start';
  }

  return (
    <label style={labelStyle} className={className}>
      <input type="checkbox" {...props} />
      {children && <span>{children}</span>}
    </label>
  );
};
